<template>
  <section class="cta-section">
    <div class="cta-bg" aria-hidden="true">
      <div class="cta-blob-1"></div>
      <div class="cta-blob-2"></div>
    </div>
    <div class="section-container">
      <div class="cta-content">
        <div class="cta-icon">📖</div>
        <h2 class="cta-title">ابدأ رحلتك في إتقان اللغة العربية</h2>
        <p class="cta-sub">تعلم النحو والبلاغة والأدب بأسلوب مبسط وحديث مع أ/ طارق المحلاوي</p>
        <div class="cta-actions">
          <router-link to="/login" class="btn-primary">ابدأ التعلم الآن ✒️</router-link>
          <a href="https://wa.me/+201021631271" target="_blank" class="btn-wa">
            <i class="pi pi-whatsapp"></i> تواصل مع الأستاذ
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.section-container { max-width:1200px;margin:0 auto;padding:0 2rem; }

.btn-primary, .btn-wa { display:inline-flex;align-items:center;justify-content:center;gap:.6rem;padding:.9rem 2rem;border-radius:99px;font-weight:700;font-size:1rem;text-decoration:none;transition:all .3s cubic-bezier(.4,0,.2,1);border:none;cursor:pointer;font-family:'Cairo',sans-serif; }
.btn-primary { background:linear-gradient(135deg,#D4AF37,#B8960B);color:#0F0F0F;box-shadow:0 12px 32px rgba(212,175,55,.3); }
.btn-primary:hover { transform:translateY(-3px);box-shadow:0 20px 50px rgba(212,175,55,.45);color:#0F0F0F; }
.btn-wa { background:linear-gradient(135deg,#25d366,#128C7E);color:#fff;box-shadow:0 12px 30px rgba(37,211,102,.25); }
.btn-wa:hover { transform:translateY(-3px);box-shadow:0 20px 45px rgba(37,211,102,.4);color:#fff; }

.cta-section { padding:7rem 0;position:relative;overflow:hidden;background:linear-gradient(135deg,#080808 0%,#111111 45%,#0A0A0A 100%);font-family:'Cairo',sans-serif;direction:rtl; }
.cta-bg { position:absolute;inset:0;pointer-events:none; }
.cta-blob-1 { position:absolute;width:500px;height:500px;border-radius:50%;background:radial-gradient(circle,rgba(212,175,55,.22),transparent);top:-150px;right:-100px;filter:blur(60px);animation:blobMove 8s ease-in-out infinite; }
.cta-blob-2 { position:absolute;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(184,134,11,.14),transparent);bottom:-120px;left:-80px;filter:blur(60px);animation:blobMove 10s ease-in-out infinite reverse; }
.cta-content { display:flex;flex-direction:column;align-items:center;text-align:center;gap:1.25rem;position:relative;z-index:1; }
.cta-icon { font-size:3.5rem;animation:floatY 3s ease-in-out infinite; }
.cta-title { font-size:clamp(1.8rem,4vw,2.8rem);font-weight:900;color:#F0EDE4; }
.cta-sub { font-size:1.05rem;color:rgba(240,237,228,.7);max-width:520px; }
.cta-actions { display:flex;gap:1rem;flex-wrap:wrap;justify-content:center;margin-top:.5rem; }

@keyframes blobMove { 0%,100%{transform:scale(1) translate(0,0)} 33%{transform:scale(1.1) translate(30px,-30px)} 66%{transform:scale(.9) translate(-20px,20px)} }
@keyframes floatY { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }

@media(max-width:600px) { .cta-section { padding:5rem 0; } .cta-actions { flex-direction:column;align-items:center; } }
</style>
